import {
  validationSchemas,
  commonValidationRules,
  validateField,
  validateForm,
} from './validation.schemas';

// Export all validation schemas for easy import
export { validationSchemas, commonValidationRules, validateField, validateForm };

// Common form initial values
export const initialValues = {
  login: {
    email: '',
    password: '',
    rememberMe: false,
  },

  register: {
    displayName: '',
    email: '',
    phoneNumber: '',
    referralCode: '',
    password: '',
    confirmPassword: '',
    agreeUserAgreement: false,
    agreePrivacyPolicy: false,
    agreeElectronicDisclosures: false,
  },

  inviteRegister: {
    password: '',
    confirmPassword: '',
    inviteCode: '',
    agreeUserAgreement: false,
    agreePrivacyPolicy: false,
    agreeElectronicDisclosures: false,
  },

  forgotPassword: {
    email: '',
  },

  resetPassword: {
    password: '',
    confirmPassword: '',
  },

  changePassword: {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: '',
  },

  userProfile: {
    name: '',
    email: '',
    phone: '',
    address: '',
    bio: '',
  },

  settings: {
    siteName: '',
    siteUrl: '',
    adminEmail: '',
    supportEmail: '',
  },

  product: {
    name: '',
    description: '',
    price: 0,
    category: '',
    stock: 0,
  },

  contact: {
    name: '',
    email: '',
    subject: '',
    message: '',
  },
};

// Helper function to get schema by name
export const getValidationSchema = (schemaName: keyof typeof validationSchemas) => {
  return validationSchemas[schemaName];
};

// Helper function to get initial values by name
export const getInitialValues = (formName: keyof typeof initialValues) => {
  return initialValues[formName];
};

// Common validation patterns
export const patterns = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  phone: /^[0-9+\-\s()]+$/,
  username: /^[a-zA-Z0-9_]+$/,
  url: /^https?:\/\/.+/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{6,}$/, // At least 6 chars, 1 lowercase, 1 uppercase, 1 number
};

// Validation messages
export const messages = {
  required: (field: string) => `Please enter ${field}`,
  email: 'Invalid email address',
  minLength: (min: number) => `Must be at least ${min} characters`,
  maxLength: (max: number) => `Must not exceed ${max} characters`,
  password: 'Password must be at least 6 characters',
  confirmPassword: 'Passwords do not match',
  phone: 'Invalid phone number',
  url: 'Invalid URL',
  number: 'Must be a number',
  positiveNumber: 'Must be a positive number',
  date: 'Invalid date',
};
